import { Box, Checkbox } from "@mantine/core";

interface PriorityCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const PriorityCheckbox = ({ label, checked, onChange, disabled }: PriorityCheckboxProps) => {
  return (
    <Box
      px="sm"
      py="xs"
      style={{
        border: "1px solid var(--mantine-color-gray-3)",
        borderRadius: "var(--mantine-radius-md)",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <Checkbox
        label={label}
        labelPosition="left"
        size="xs"
        styles={{
          body: { justifyContent: "space-between" },
          label: { fontSize: 14, cursor: disabled ? "default" : "pointer" },
          input: { cursor: disabled ? "default" : "pointer" },
        }}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
    </Box>
  );
};

export default PriorityCheckbox;
